<!-- <div class="page-title-area" *ngFor="let Content of pageTitle;" style="background-image: url({{Content.bgImage}});">
    <div class="container">
        <h1>{{Content.title}}</h1>
    </div>
</div> -->

<div class="profile-authentication-area ptb-30">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 offset-lg-3 col-md-12">
        <div class="login-form">
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12">
              <h2>{{resource.signUp}}</h2>
            </div>
            <div style="text-align: right;" class="col-lg-8 col-md-12 col-sm-12">
              {{resource.already_have_account}} ? <a href="javascript:void(0)" style="font-weight: bold;"
                class="sign-up" (click)="navigateToSignin()">{{resource.signIn}}</a>
            </div>
          </div>
          <form [formGroup]="registerForm" (ngSubmit)="onSubmitRegister()" autocomplete="off">
            <div class="row">
              <!-- <div class="col-md-12">
                <div class="form-group">
                  <mat-form-field>
                    <mat-label>{{resource.firstName}}</mat-label>
                    <input matInput [placeholder]="resource.firstName" formControlName="firstName" type="text"
                      maxlength="50">
                    <mat-error *ngIf="submittedRegister && fReg.firstName.errors?.required" class="invalid-feedback">
                      {{resource.firstName}} {{resource.is_required}}
                    </mat-error>
                    <mat-error *ngIf="fReg.firstName.errors?.required && fReg.firstName.touched"
                      class="invalid-feedback">*{{resource.firstName}} cannot be kept as blank.</mat-error>
                  </mat-form-field>
                </div>
              </div> -->
              <!-- <div class="col-lg-6 col-md-12">
                <div class="form-group">
                   <label>{{resource.last_name}} </label>
                  <mat-form-field>
                    <mat-label> {{resource.last_name}}</mat-label>
                    <input matInput [placeholder]="resource.last_name" formControlName="lastName" type="text" maxlength="50">
                    <mat-error *ngIf="submittedRegister && fReg.lastName.errors?.required" class="invalid-feedback">
                      {{resource.last_name}} {{resource.is_required}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div> -->
            </div>
            <!-- <div class="row">
              <div class="col-lg-4 col-md-12">
                <div class="form-group">
                   <label>{{resource.country}} </label>
                  <mat-form-field>
                    <mat-label> {{resource.country}}</mat-label>
                    <mat-select [placeholder]="resource.country" formControlName="country" (selectionChange)="onChangeCountry($event)">
                      <mat-option>{{resource.country}}</mat-option>
                      <mat-option *ngFor="let country of countryList" [value]="country.id">
                        {{country.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="submittedRegister && fReg.country.errors?.required" class="invalid-feedback">
                      {{resource.country}} {{resource.is_required}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4">
                <div class="form-group">
                   <label>{{resource.state}} </label>
                  <mat-form-field>
                    <mat-label> {{resource.state}}</mat-label>
                    <mat-select [placeholder]="resource.state" formControlName="stateId" (selectionChange)="onChangeState($event)">
                      <mat-option>{{resource.state}}</mat-option>
                      <mat-option *ngFor="let state of stateList" [value]="state.id">
                        {{state.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="submittedRegister && fReg.stateId.errors?.required" class="invalid-feedback">
                      {{resource.state}} {{resource.is_required}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4">
                <div class="form-group">
                  <label>{{resource.city}}</label>
                  <mat-form-field>
                    <mat-label> {{resource.city}}</mat-label>
                    <mat-select [placeholder]="resource.city" formControlName="cityId">
                      <mat-option>{{resource.city}}</mat-option>
                      <mat-option *ngFor="let city of cityList" [value]="city.id">
                        {{city.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="submittedRegister && fReg.cityId.errors?.required" class="invalid-feedback">
                      {{resource.city}} {{resource.is_required}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div> -->

            <div class="row">
              <!-- <div class="col-lg-2 col-md-6">
                <div class="form-group">
                  <label>Country Code</label>
                  <mat-form-field>
                    <input matInput formControlName="countryCode" type="text" readonly="">
                  </mat-form-field>
                </div>
              </div> -->
              <div class="col-md-12">
                <div class="form-group">
                  <!-- <label>{{resource.email}}</label> -->
                  <mat-form-field>
                    <mat-label> {{resource.email}}</mat-label>
                    <input matInput [placeholder]="resource.email" formControlName="email"
                      oninput="this.value = this.value.toLowerCase()" type="email" maxlength="30">
                    <mat-error *ngIf="submittedRegister && fReg.email.errors?.required" class="invalid-feedback">
                      {{resource.email}} {{resource.is_required}}
                    </mat-error>
                    <mat-error
                      *ngIf="submittedRegister  && fReg.email.errors?.pattern && (registerForm.touched || registerForm.dirty)"
                      class="invalid-feedback">
                      {{resource.invalid}} {{resource.email}}
                    </mat-error>
                    <mat-error *ngIf="fReg.email.errors?.required && fReg.email.touched"
                      class="invalid-feedback">*{{resource.email}} cannot be kept as blank.</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <!-- <div class="col-lg-6 col-md-6">
                <div class="form-group">
                   <label>{{resource.telephone}}</label> -->
              <!-- <mat-form-field>
                    <mat-label> {{resource.telephone}}</mat-label>
                    <span style="margin-left: 5px;" matPrefix>+{{countryCode}} &nbsp;</span>
                    <input matInput [placeholder]="resource.telephone" formControlName="telephone" OnlyNumber type="tel" maxlength="15">
                    <mat-error *ngIf="submittedRegister && fReg.telephone.errors?.required" class="invalid-feedback">
                      {{resource.telephone}} {{resource.is_required}}
                    </mat-error>
                    <mat-error class="invalid-feedback" *ngIf="submittedRegister && (fReg.telephone.errors?.minlength)">
                      {{resource.telephone_must_10_digit}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div> -->
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <!-- <label>{{resource.password}}</label> -->
                  <mat-form-field class="dense-2">
                    <mat-label>{{ resource.password }}</mat-label>
                    <input matInput [placeholder]="resource.password" formControlName="password" class="passwordheight"
                      [type]="hide ? 'password' : 'text'" maxlength="20">

                    <mat-error *ngIf="submittedRegister && fReg.password.errors?.required" class="invalid-feedback">
                      {{ resource.password }} {{ resource.is_required }}
                    </mat-error>
                    <mat-error *ngIf="submittedRegister && fReg.password.errors?.pattern" class="invalid-feedback">
                      {{ resource.password }} {{ resource.passwordInformation }}
                    </mat-error>


                    <i class="password bx bx-info-circle tooltip-icon"></i>
                    <button type="button" class="password" matTooltip="Show Password"
                      aria-label="Button that displays a tooltip when focused or hovered over" mat-icon-button matSuffix
                      (click)="togglePasswordVisibility()" [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
                      [attr.aria-pressed]="hide">
                      <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <span class="tooltip-text">
                      <ol>
                        <span class="passinfoheading">{{ resource.passwordRequirement }}</span>
                        <li>{{ resource.minlengthInfo }}</li>
                        <li>{{ resource.passwordInfo }}</li>
                      </ol>
                    </span>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <mat-form-field>
                    <mat-label>{{ resource.confirm_password }}</mat-label>
                    <input matInput [placeholder]="resource.confirm_password" formControlName="confirmPassword"
                      class="passwordheight" [type]="hidePasswordConfirm ? 'password' : 'text'" maxlength="20">
                    <button type="button" class="password" matTooltip="Show Password"
                      aria-label="Button that displays a tooltip when focused or hovered over" mat-icon-button matSuffix
                      (click)="toggleConfirmPasswordVisibility()"
                      [attr.aria-label]="hidePasswordConfirm ? 'Show password' : 'Hide password'"
                      [attr.aria-pressed]="hide">
                      <mat-icon>{{hidePasswordConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error *ngIf="submittedRegister && fReg.confirmPassword.errors?.required">
                      {{ resource.confirm_password }} {{ resource.is_required }}
                    </mat-error>
                    <mat-error *ngIf="submittedRegister && fReg.confirmPassword.errors?.mustMatch">
                      {{ resource.password_not_match }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div> -->
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <mat-checkbox formControlName="termsCondition"
                    (change)="onClickTermCondition()">{{resource.term_conditions}}
                  </mat-checkbox>
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-6 offset-lg-3 col-md-12"> -->
            <button [disabled]="!fReg.termsCondition.value" type="submit">{{resource.signUp}} </button>
            <!-- </div> -->
          </form>
          <div class="or-divider">OR</div>

          <div class="mt-2">
              <button type="button" class="google-login-btn" (click)="loginWithGoogle()">
                  <img src="assets/img/google_icon.png" alt="Google Logo">
                  Continue with Google
              </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>